import React, { useState } from "react";
import PropTypes, { string } from "prop-types";
import styled from "styled-components";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { NumericFormat } from 'react-number-format';


import OpacityIcon from "@mui/icons-material/Opacity";

const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: black;
  background: white;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
`;



const CardTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
  max-width: 15em;
`;

const CardSubTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.1rem;
  margin-left: 0.3rem;
  font-weight: 500;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;

const HighchartsContainer = styled.div`
  margin-top: 1.5rem;
  margin-right: 1rem;
`;

function CustomCard(props) {
  let year = new Date();
  year = new Date(year.setMonth(year.getMonth()-1));
  year = year.getFullYear();

  return (
    <div>
      <Card>
      <TitleContainer>
        <CardTitle>Consommation {props.cardTitle}</CardTitle>
        <CardSubTitle><NumericFormat value={props.cardSubTitle} displayType={'text'} thousandSeparator={' '} decimalSeparator={','} decimalScale={2} /> {props.cardSubTitleUnit} ({year})</CardSubTitle>
        </TitleContainer>
        <HighchartsContainer>
          <HighchartsReact highcharts={Highcharts} options={props.options} />
        </HighchartsContainer>
      </Card>
    </div>
  );
}

CustomCard.propTypes = {
  cardTitle: PropTypes.string,
  cardSubTitle: PropTypes.string,
  cardSubTitleUnit: PropTypes.string,
  chart: PropTypes.any,
  dataChart: PropTypes.any,
  options: PropTypes.object,
};

export default CustomCard;
